// extracted by mini-css-extract-plugin
export default {"starterScreen":"Lm","starterImage":"Mm","already":"Nm","btnContainer":"Om","starterImageMobile":"Pm","starterTextContainWrapper":"Qm","controlX":"Rm","attrWrapper":"Sm","logoWrapper":"Tm","starterTextContain":"Um","starterHeader":"Vm","starterBtn":"Wm","starterSecondaryBtn":"Xm","starterBanner":"Ym","logoWrapperMob":"Zm","mobileBtnContainer":"an"};
    if(module.hot) {
      // 1715091668880
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  